import classnames from 'classnames';
import { string, shape, arrayOf } from 'prop-types';
import React from 'react';

import DefaultItem from '../DefaultItem';

import styles from './DefaultCard.module.scss';

const DefaultCard = (props) => {
  const { title, info, variant, description } = props;
  const wrapperClasses = classnames(styles.wrapper, styles[`variant-${variant}`]);

  return (
    <div className={wrapperClasses}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
      <div className={styles.container}>
        <div className={styles.grid}>
          {info.map((item) => (
            <div className={styles.gridItem} key={item.title}>
              <DefaultItem data={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

DefaultCard.propTypes = {
  title: string,
  description: string,
  info: arrayOf(
    shape({
      title: string,
      description: string,
    }),
  ),
  variant: string,
};

DefaultCard.defaultProps = {
  title: '',
  description: '',
  info: [{ numbertitle: '', description: '' }],
  variant: '',
};

export default DefaultCard;
